import React from "react"
import styled from "styled-components"
import { getCssSizeValue, getHtmlFromRedactorField } from "@/utils/utils"
import HowWeHelpTile from "@/components/TilesModule/variants/HowWeHelp/HowWeHelpTile"
import GridContainerRectangles from "@/components/common/GridContainerRectangles"
import GridContainer from "@/components/common/GridContainer"
import { BREAKPOINTS } from "@/styles/themeSettings"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const TilesRectangleGridContainer = styled.div`
	width: 100%;
	position: relative;
	background-color: ${({ theme, backgroundColor }) => theme.colors[backgroundColor]};
	padding: ${getCssSizeValue(80, BREAKPOINTS.MOBILE)} 0 ${getCssSizeValue(60, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		padding: ${getCssSizeValue(100, BREAKPOINTS.TABLET)} 0 ${getCssSizeValue(105, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(112, BREAKPOINTS.DESKTOP)} 0;
	}
`

const HeadingWrapper = styled(GridContainer)`
	margin-bottom: ${getCssSizeValue(56, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(56, BREAKPOINTS.DESKTOP)};
	}
`

const TilesWrapper = styled(GridContainerRectangles)`
	//grid-template-columns: 1fr;
	grid-template-columns: repeat(8, 1fr);
	padding: 0 calc(100vw / 8);
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		grid-template-columns: repeat(8, 1fr);
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		grid-template-columns: repeat(16, 1fr);
		padding: 0;
	}
`

const Index = ({ data, headerDescription }) => {
	const backgroundColor = data?.backgroundColor?.color || null
	const heading = data?.heading || ""
	const items = data?.tiles || []
	return (
		<TilesRectangleGridContainer backgroundColor={backgroundColor}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<HeadingWrapper className="indent-desktop-1 col-mobile-8 col-tablet-4 col-desktop-8">
				<div
					className="typo-borna typo-borna-89 col-mobile-8 col-tablet-7 col-desktop-8"
					dangerouslySetInnerHTML={getHtmlFromRedactorField(heading)}
				/>
			</HeadingWrapper>
			<TilesWrapper className="indent-desktop-1">
				{items.map((item, index) => {
					const key = item?.id || index
					return <HowWeHelpTile item={item} key={key} isRectangle />
				})}
			</TilesWrapper>
		</TilesRectangleGridContainer>
	)
}

export default Index
